import { render, staticRenderFns } from "./UserBookingList.vue?vue&type=template&id=675074b2"
import script from "./UserBookingList.vue?vue&type=script&lang=js"
export * from "./UserBookingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports